export default __webpack_public_path__ + "static/media/DorinaLovelace.ae9647a9.png";